import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule as CorePipeModule } from '@smooved/core';
import { ButtonModule, CardsModule, UiContext, UiFormModule, WizardModule, WizardService, WIZARD_CONFIG, TooltipModule } from '@smooved/ui';
import { TranslateLabelPipe } from 'projects/core/src/lib/pipes/translate-label.pipe';
import { TemplateLoaderModule } from 'projects/ui/src/lib/template-loader/template-loader.module';
import { QuestionAddressComponent } from './components/address/question-address.component';
import { CategoryComponent } from './components/category/category.component';
import { QuestionContactPersonComponent } from './components/contact-person/question-contact-person.component';
import { QuestionFreeTextComponent } from './components/free-text/question-free-text.component';
import { MetaInfoComponent } from './components/meta-info/meta-info.component';
import { PageInterviewComponent } from './components/page/page-interview.component';
import { QuestionContainerComponent } from './components/question-container/question-container.component';
import { QuestionComponent } from './components/question/question.component';
import { QuestionScoreComponent } from './components/score/question-score.component';
import { QuestionSelectionComponent } from './components/selection/question-selection.component';
import { StartInterviewContainer } from './components/start-interview/start-interview.container';
import { SurveyInterviewContainer } from './components/survey-interview/survey-interview.container';
import { QuestionTextComponent } from './components/text/question-text.component';
import { QuestionTitlePipe } from './pipes/question-title.pipe';
import { QuestionTranslateLabelPipe } from './pipes/question-translate-label.pipe';
import { SurveyWizardService } from './services/survey-wizard.service';
import { SurveyEffects } from './state/surveys.effects';
import { surveyReducer } from './state/surveys.reducer';
import { SurveyProvidersModule } from './survey-providers.module';
import { SurveyRoutingModule } from './survey-routing.module';
import { InlineSVGModule } from 'ng-inline-svg-2';

const components = [
    QuestionTranslateLabelPipe,
    QuestionTitlePipe,
    CategoryComponent,
    QuestionComponent,
    QuestionContactPersonComponent,
    QuestionFreeTextComponent,
    QuestionSelectionComponent,
    QuestionTextComponent,
    MetaInfoComponent,
    PageInterviewComponent,
    QuestionScoreComponent,
    QuestionAddressComponent,
    QuestionContainerComponent,
    SurveyInterviewContainer,
    StartInterviewContainer,
];

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        UiFormModule,
        CardsModule,
        CorePipeModule,
        TranslateModule,
        StoreModule.forFeature('survey', surveyReducer),
        EffectsModule.forFeature([SurveyEffects]),
        TemplateLoaderModule,
        ButtonModule,
        WizardModule,
        SurveyProvidersModule,
        SurveyRoutingModule,
        InlineSVGModule,
        TooltipModule,
    ],
    providers: [
        { provide: TranslateLabelPipe, useClass: QuestionTranslateLabelPipe },
        {
            provide: WizardService,
            useExisting: SurveyWizardService,
        },
        {
            provide: WIZARD_CONFIG,
            useValue: { useRouterSteps: false, submitButtonContext: UiContext.Primary },
        },
    ],
    exports: [...components],
})
export class SurveyModule {}
